import { render, staticRenderFns } from "./AssetContainerItem.vue?vue&type=template&id=71f10821&scoped=true&"
import script from "./AssetContainerItem.vue?vue&type=script&lang=js&"
export * from "./AssetContainerItem.vue?vue&type=script&lang=js&"
import style0 from "./AssetContainerItem.vue?vue&type=style&index=0&id=71f10821&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f10821",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
